/**
 * Validation Types
 * Shared type definitions for field validation.
 */
// ============================================================================
// Operator Text Mapping
// ============================================================================
export const operatorText = {
    '<': 'less than',
    '<=': 'less than or equal to',
    '>': 'greater than',
    '>=': 'greater than or equal to',
    '==': 'equal to',
    '!=': 'not equal to',
};
//# sourceMappingURL=validation.types.js.map